import type { Action } from 'redux';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const SetActiveTemplateId = new ReduxAsyncAction<
  'SET_ACTIVE_TEMPLATE_ID',
  string | null | undefined,
  string | null | undefined
>('SET_ACTIVE_TEMPLATE_ID');

SetActiveTemplateId.registerRequest(async (activeTemplateId?: string | null) => {
  return activeTemplateId;
});

export const SET_ACTIVE_TEMPLATE_ID = SetActiveTemplateId.actionNamespaceConstants;

export const setActiveTemplateId = SetActiveTemplateId.request;

export type SetActiveTemplateIdResponseAction = Action<typeof SET_ACTIVE_TEMPLATE_ID.response> & { data: string | null };
